import React from 'react';
import { useT } from '../../i18n';
import './StepIndicator.css';

// The booking wizard steps (step 6 = success, 0 = failure — no indicator there).
// ★ F1 — התוויות הן **מפתחות**; התרגום קורה ברינדור כדי שהחלפת-שפה תתפוס מיד.
const STEPS = [
  { n: 1, key: 'steps.details' },
  { n: 2, key: 'steps.department' },
  { n: 3, key: 'steps.service' },
  { n: 4, key: 'steps.date' },
  { n: 5, key: 'steps.approval' },
];

export default function StepIndicator({ currentStep, goToStep, readOnly }) {
  const t = useT();
  if (currentStep < 1 || currentStep > 5) return null;
  return (
    <div className="step-indicator">
      {STEPS.map((s, i) => {
        const label = t(s.key);
        const state =
          currentStep === s.n ? 'si-active' : currentStep > s.n ? 'si-done' : 'si-todo';
        // jump back to a completed step (disabled in read-only mode, e.g. the edit screen)
        const clickable = !readOnly && s.n < currentStep;
        return (
          <React.Fragment key={s.n}>
            <div
              className={'si-step ' + state + (clickable ? ' si-clickable' : '')}
              onClick={() => clickable && goToStep && goToStep(s.n)}
              aria-current={currentStep === s.n ? 'step' : undefined}
              // a11y (WCAG 2.1.1): only the clickable (completed) steps are keyboard-operable
              {...(clickable ? {
                role: 'button',
                tabIndex: 0,
                'aria-label': t('steps.backToStep', { label }),
                onKeyDown: (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); goToStep && goToStep(s.n); } },
              } : {})}
            >
              <div className="si-circle">{currentStep > s.n ? '✓' : s.n}</div>
              <div className="si-label">{label}</div>
            </div>
            {i < STEPS.length - 1 && (
              <div className={'si-line ' + (currentStep > s.n ? 'si-line-done' : '')} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
